type TableColumn = {
  key: string;
  label: string;
  hasDivider: boolean;
  tooltip?: string;
};

export function getTableColumns(showSeatDays: boolean): TableColumn[] {
  const periodLabel = showSeatDays ? 'Seat-days' : 'Period QTY';

  return [
    { key: 'from', label: 'From', hasDivider: false },
    { key: 'to', label: 'To', hasDivider: true },
    { key: 'unitPrice', label: 'Price', hasDivider: false },
    {
      key: 'bulkSize',
      label: 'Bulk size',
      hasDivider: false,
      tooltip: 'Charge per bulk (package) of units.\nPrice applies to the entire unit pack',
    },
    { key: 'flatRate', label: 'Flat rate', hasDivider: false },
    ...(showSeatDays ? [] : [{ key: 'ytdQty', label: 'YTD QTY', hasDivider: false }]),
    { key: 'periodQty', label: periodLabel, hasDivider: showSeatDays },
    ...(showSeatDays
      ? []
      : [
          {
            key: 'billableQty',
            label: 'Billable QTY',
            hasDivider: true,
            tooltip:
              'The quantity that will actually be charged\nfor this tier in the current billing period',
          },
        ]),
    { key: 'amount', label: 'Amount', hasDivider: false },
  ];
}
